import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./Login.css";

function BillingCancel() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Checkout Cancelled</h2>
        <p className="subtitle">No payment was made. You can retry upgrade anytime.</p>
        <button
          className="login-button"
          onClick={() => navigate(isAuthenticated ? "/settings/profile" : "/login")}
        >
          {isAuthenticated ? "Back to Account" : "Back to Login"}
        </button>
      </div>
    </div>
  );
}

export default BillingCancel;
